var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "appleTips" } }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("language.popup.appleTipsPopup.title")))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-body" }, [
          _c("div", { staticClass: "popup-title-tips" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("language.popup.appleTipsPopup.tipTitle")))
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("language.popup.appleTipsPopup.tip1")))
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("language.popup.appleTipsPopup.tip2")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "popup-btns" }, [
            _c("div", { staticClass: "popup-check-btn" }, [
              _c("div", {
                staticClass: "icon-util",
                class: _vm.isCheck ? "check" : "nocheck",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.check()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.$t("language.popup.appleTipsPopup.checkTip")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.submitOk()
                  }
                }
              },
              [
                _c("span", { staticClass: "button-tip" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.ok")))
                ])
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8338cf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8338cf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/apple_tips_popup.vue
// module id = null
// module chunks = 